<template>
  <v2-row noSpace>
    <v2-col col12 noSpaceX noSpace>
      <div class="v2-input">
        <label class="mb-0">{{ $t("quickLaunch.labels.countdown.expirationDate") }}</label>
      </div>
      <date-picker
        class="envivo-datetimepicker mb-8"
        v-model="validUntil"
        :lang="teams[$route.params.team].account.locale"
        type="datetime"
        :formatter="datetimeFormat"
        :minute-step="1"
        :show-second="false"
        :first-day-of-week="1"
        @input="setChangedComp()"
      >
      </date-picker>
      <input v-model="validUntil" name="validUntil" v-show="false" />
      <v2-redactor
        :label="$t('quickLaunch.labels.countdown.textContent')"
        minHeight="300px"
        v-model="textContent"
        name="textContent"
        :config="redactorCustomConfig"
        @input="setChangedComp()"
      />
      <v2-redactor
        :label="$t('quickLaunch.labels.countdown.expiredTextContent')"
        minHeight="300px"
        v-model="expiredTextContent"
        name="expiredTextContent"
        :config="redactorCustomConfig"
        @input="setChangedComp()"
      />
    </v2-col>
    <v2-col col12 class="items-end" noSpaceX noSpace>
      <v2-button outline primary @click.native="saveComponent(false)">{{ $t("quickLaunch.actions.save") }}</v2-button>
    </v2-col>
  </v2-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "QuickLaunchCountdown",
  props: {
    component: Object,
  },
  data() {
    return {
      hasChanged: false,
      redactorCustomConfig: {
        plugins: ["variablesDropdown"],
        variables: [
          {
            title: "owner_name",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${owner:first_name}",
            api: "plugin.variablesDropdown.insertVar",
          },
          {
            title: "owner_surname",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${owner:last_name}",
            api: "plugin.variablesDropdown.insertVar",
          },
          {
            title: "contact_name",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${contact:first_name}",
            api: "plugin.variablesDropdown.insertVar",
          },
          {
            title: "contact_surname",
            // eslint-disable-next-line no-template-curly-in-string
            args: "${contact:last_name}",
            api: "plugin.variablesDropdown.insertVar",
          },
        ],
      },
      validUntil: null,
      textContent: "",
      expiredTextContent: "",
      datetimeFormat: {
        stringify: (date) => {
          return date
            ? this.$moment(date).tz(this.teams[this.$route.params.team].account.timezone).format("L HH:mm")
            : null;
        },
        parse: (value) => {
          return value
            ? this.$moment(value, "L HH:mm").tz(this.teams[this.$route.params.team].account.timezone).toDate()
            : null;
        },
      },
    };
  },
  created() {
    this.textContent = this.component.value.textContent;
    this.expiredTextContent = this.component.value.expiredTextContent;
    this.validUntil = new Date(this.component.value.valid_until);
    this.$eventbus.$on("saveComponents", () => {
      this.saveComponent(true);
    });
  },
  methods: {
    ...mapActions(["updateComponent", "getProjectComponent"]),
    setChangedComp() {
      this.hasChanged = true;
      this.$eventbus.$emit("setUnsavedComponents", this.component.uid);
    },
    saveComponent(isEvent = false) {
      if (this.hasChanged) {
        const vm = this;
        const data = {
          customLoading: true,
          params: {
            project: vm.currentProject.uid,
            component: vm.component.uid,
          },
          data: {
            encoded: ["expiredTextContent", "textContent"],
            value: {
              expiredTextContent:
                vm.expiredTextContent && vm.expiredTextContent !== ""
                  ? this.$base64.encode(vm.expiredTextContent)
                  : vm.expiredTextContent,
              textContent:
                vm.textContent && vm.textContent !== "" ? this.$base64.encode(vm.textContent) : vm.textContent,
              valid_until: vm.validUntil,
            },
          },
        };
        vm.updateComponent(data)
          .then(() => {
            vm.$eventbus.$emit("componentSavedSuccess", this.component.uid, isEvent);
            vm.hasChanged = false;
            if (!isEvent) {
              vm.$snotify.success(vm.$t("quickLaunch.toasts.saveComponent.success"), vm.$t("toasts.success"), {
                icon: vm.$successIcon,
              });
              vm.reloadComponent();
            }
          })
          .catch(() => {
            vm.$eventbus.$emit("componentSavedError", this.component.uid);
            if (!isEvent) {
              vm.$snotify.error(vm.$t("quickLaunch.toasts.saveComponent.error"), vm.$t("toasts.error"), {
                timeout: 0,
                icon: vm.$errorIcon,
              });
            }
          });
      }
    },
    reloadComponent() {
      this.getProjectComponent({
        customLoading: true,
        params: {
          project: this.currentProject.uid,
          component: this.component.uid,
        },
      }).then(() => {});
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      currentProject: "projects_get_current_project",
    }),
  },
};
</script>

<style lang="scss"></style>
